const PUBLIC_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "protonmail.com",
  "pm.me",
  "zoho.com",
  "yandex.com",
  "gmx.com",
  "mail.com",
  "rediffmail.com",
  "ymail.com",
  "emirates.net.ae",
  "eim.ae",
  "etisalat.ae",
  "du.ae",
];

export const getEmailDomain = (email = "") => {
  const normalizedEmail = email.trim().toLowerCase();
  const domain = normalizedEmail.split("@")[1];
  return domain || "";
};

export const isPublicEmailDomain = (email = "") => {
  const domain = getEmailDomain(email);
  return PUBLIC_EMAIL_DOMAINS.includes(domain);
};

export const isCorporateEmail = (email = "") => {
  if (!email) return false;
  return !isPublicEmailDomain(email);
};
